import { useSite } from "@/context/SiteContext";
import Hero from "@/components/marketing/Hero";
import SelectedWork from "@/components/marketing/SelectedWork";
import ChooseExperience from "@/components/marketing/ChooseExperience";
import Manifesto from "@/components/marketing/Manifesto";
import TestimonialFeature from "@/components/marketing/TestimonialFeature";
import FinalCTA from "@/components/marketing/FinalCTA";

export default function Home() {
  const { settings, services } = useSite();
  return (
    <main data-testid="home-page">
      <Hero settings={settings} />
      <SelectedWork />
      <ChooseExperience services={services} />
      <Manifesto settings={settings} />
      <TestimonialFeature />
      <FinalCTA settings={settings} />
    </main>
  );
}
